import '@sapudex/web-components/dist/Tab.js';
import '@sapudex/web-components/dist/TabNavigation.js';
import {AfterViewInit, Component, CUSTOM_ELEMENTS_SCHEMA, Input} from '@angular/core';

@Component({
  selector: 'dcp-tab-navigation',
  // using href to force full page reload when clicking the tabs as routerLinks do not work
  templateUrl: './tab-navigation.component.html',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class TabNavigationComponent implements AfterViewInit {
  @Input() selectedTab: 'transactions' | 'product-determination' | 'cta-validation' | 'products';

  /**
   * Workaround to remove the shadow DOM element that is causing issues with the layout
   * (too much spacing between tabs and content).
   */
  ngAfterViewInit() {
    window.setTimeout(() => {
      const tabNav = document.querySelector('udex-tab-navigation');
      if (tabNav && tabNav.shadowRoot) {
        tabNav.shadowRoot.querySelector('.udex-tab-navigation__content')?.remove();
      }
    }, 100);
  }
}
